export const REDUX_LOAD_STATUS = {
  LOADING: "loading",
  ERROR: "error",
  IDLE: "idle"
};

export const MODAL_TYPE_ENUM = {
  GENERAL_FAILURE: 'generalFailure',
  GENERAL_SUCCESS: '  ',
  GENERAL_INFO: 'generalInfo',
  LOGIN_FAILURE: 'loginFailure',
  RESET_PASSWORD_FAILURE: 'resetPasswordFailure',
  RESET_PASSWORD_SUCCESS: 'resetPasswordSuccess',
  REGISTRATION_FILE_FAILURE: 'registrationFileFailure'

}
